// extracted by mini-css-extract-plugin
module.exports = {"table":"oynRKvk3S9ybWumZtdnxa","header":"_5i1J3LGQHJZFm98H3UT1c","row":"_3Bhv9Wk_pth-HWw8lUfDtN","headerCell":"_3S_SOr_J5EKhHRyUf_0Ozg","cell":"_2_wdpZ0JA5Y8j7dFs5XArY"};